import { useQuery } from '@tanstack/react-query';

import { getUserAuthProfile } from '../services/individualBioService';
import { UserAuthProfile } from '../types';

export const useUserAuthProfile = (userId?: string | null) => {
  const { data, isLoading, error } = useQuery<UserAuthProfile, Error>({
    queryKey: ['userAuthProfile', userId],
    queryFn: () => getUserAuthProfile(userId!),
    enabled: !!userId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    userProfile: data || null,
    loading: isLoading,
    error: error?.message || null,
  };
};
